import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { message } from 'antd'


export const getFooterPost = createAsyncThunk('getFooterStatistics',
    async (object, { dispatch, getState }) => {
        dispatch(gettingFooterDetail())
        var myHeaders = new Headers();
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow',
        };
        fetch(domainUrl + `/viewFooterDetails`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(footerResponse(result?.data))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(footerClear())
                message.error(error) 
            })
    }
)




const FooterGetAllSlice = createSlice({
    name: 'footerdetailapi',
    initialState: {
        footerData: null,
    },
    reducers: {
        gettingFooterDetail: state => {
            state.footerData=null
        },
        footerResponse: (state, action)=>{
            state.footerData= action.payload
        },
        footerClear: (state)=>{
            state.footerData= null
        },
    },
})
export const { 
    gettingFooterDetail, footerResponse, footerClear
} = FooterGetAllSlice.actions;
export default FooterGetAllSlice.reducer;